export default {
    filter: 'Filter',
    fields: {
        date_from: {
            label: 'From date',
            placeholder: 'Select date',
            tool_tip_message: 'Start date of the schedule',
        },
        date_to: {
            label: 'To date',
            placeholder: 'Select date',
            tool_tip_message: 'End date of the schedule',
        },
        status: {
            label: 'Status',
            placeholder: 'Chose status',
        },
        order_by: {
            label: 'Sort by',
            placeholder: 'Chose sort',
        },
        user: {
            label: 'User',
            placeholder: 'Enter user',
        },
        company: {
            label: 'Company',
            placeholder: 'Enter company',
        },
        year: {
            label: 'Year',
            placeholder: 'Select a year',
        },
        location: {
            label: 'All locations',
            placeholder: 'All locations',
        },
    },
    sort: {
        sort: 'Sort',
        createdAt_ASC: 'Created date - Ascending',
        createdAt_DESC: 'Created date - Descending',
        updatedAt_ASC: 'Updated date - Latest',
        updatedAt_DESC: 'Updated date - Oldest',
        reservationTime_ASC: 'Scheduled for - Oldest',
        reservationTime_DESC: 'Scheduled for - Latest',
        firstName_ASC: 'First name - Ascending',
        firstName_DESC: 'First name - Descending',
        lastName_ASC: 'Last name - Ascending',
        lastName_DESC: 'Last name - Descending',
    },
}
